import dynamic from "next/dynamic"
import { useState, useEffect } from "react"
import { fetchGravityFormResult } from "@/lib/api/gravityForms"
import Storage from "@/lib/storage"
import Block from "@/components/wrappers/block"
import { Spinner } from "@/components/common/loading/spinner"
import Button from "@/components/common/button/button"
import styles from "./gravity-form-result.module.css"

export default function GravityFormResult({ block }) {
  const [isLoading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [result, setResult] = useState(null)
  const [entry, setEntry] = useState(null)
  const shareURL = block.attrs.shareURL
  const formId = block.attrs.form

  useEffect(() => {
    let isMounted = true
    if (isMounted) {
      if (!block?.attrs?.isPrivate) {
        setEntry(block?.attrs?.entryHash)

        if (block?.attrs?.result) {
          setResult(block?.attrs?.result)
        } else {
          setResult(null)
          setError(true)
        }

        setLoading(false)
        return
      }

      // check for Quiz on same path
      const quiz = Storage.get("quiz", {}, "session")

      fetchGravityFormResult(
        block.attrs.form,
        block.attrs.calculation,
        block.attrs.entryHash,
        quiz?.personal
      ).then((response) => {
        setError(response?.error)
        setResult(response?.data)
        setEntry(block.attrs.entryHash)
        setTimeout(function () {
          setLoading(false)
        }, 1000)
      })
    }
    return () => {
      isMounted = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const Result = calculations[block.attrs.calculation] ?? NotFound

  return (
    <Block block={block} className={styles.wrapper}>
      <div>
        {isLoading && (
          <div className="p-16 pb-20 text-center bg-white">
            <h1 className="mb-8">Räknar ut resultat</h1>
            <Spinner
              sizeClasses="w-48 h-48 border-6"
              borderClass="border-green-100"
              spinColor="#ECF2CA"
              className="mx-auto"
            />
          </div>
        )}
        {!isLoading && !error && (
          <Result
            result={result}
            shareURL={shareURL}
            formId={formId}
            entry={entry}
          />
        )}
        {!isLoading && error && (
          <NotFound attrs={{ ...block.attrs, shareURL }} />
        )}
      </div>
    </Block>
  )
}

const NotFound = ({ attrs }) => {
  const { heading, paragraph, button, shareURL } = attrs

  if (!heading) {
    return <span className="text-warning">Kunde inte hittas.</span>
  }

  return (
    <div className="text-warning">
      <h2>{heading}</h2>
      <p>{paragraph}</p>
      <Button ariaLabel={button} theme="lime" tagName="a" href={shareURL}>
        {button}
      </Button>
    </div>
  )
}

const calculations = {
  "election-compass": dynamic(() =>
    import("components/gravity-forms/Calculations/ElectionCompass")
  ),
  "eu-election-compass-2024": dynamic(() =>
    import("components/gravity-forms/Calculations/EuElectionCompass2024")
  ),
  "election-compass-2026": dynamic(() =>
    import("components/gravity-forms/Calculations/ElectionCompass2026")
  )
}
